module.exports = __webpack_public_path__ + "01_mole.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/01_mole.png
// module id = uBVn
// module chunks = 0